<template>
    <div class="popupalert " v-if="!hidden" v-bind:class="[message.type]">
        <div class="background"></div>
        <div class="container">
            <div class="header"><div class="label">{{message.header}}</div></div>
            <div class="description">
                {{message.description}}
            </div>
            <div class="button accept" v-bind:class="{disabled: loading}" v-on:click="Accept()">
                <div class="label" v-if="!loading">Accept</div>
                <div v-if="loading" class="loading">
                    <i class="fas fa-spinner"></i>
                </div>
            </div>
            <div class="button decline" v-bind:class="{disabled: loading}" v-on:click="Cancel()">
                <div class="label" v-if="!loading">Cancel</div>
                <div v-if="loading" class="loading">
                    <i class="fas fa-spinner"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "popupalert",

        created(){
            var message = this;
            requestAnimationFrame(function(){
                var el = message.$el;
                if((message.message.html && message.message.html != ''))
                {
                    var frame = $('<iframe></iframe>')
                    frame.parent($(el));
                    frame[0].document = message.message.html;
                    //$(el).html(message.message.html);
                }
                return;
            });

        },
        destroyed () {
        },
        data(){
            return{
                header: '',
                description: '',
                type: '',
                type: 'html',
                timer: 0,
                hidden: false,
                loading: false,
            }

        },
        methods: {
            Accept(){
                if(this.loading) return;
                if(this.message.callbackAccept) this.message.callbackAccept(this);
                else this.hidden = true;
            },
            Cancel(){
                if(this.loading) return;
                if(this.message.callbackCancel) this.message.callbackCancel(this);
                else this.hidden = true;
            },
        },
        props:{
            message: Object
        }
    }
</script>

<style scoped>
    .popupalert{
        transition: 1s;
        /*display:none;*/
        z-index: 1000;
        position: fixed;
        overflow: hidden;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        height: 100vh;
        width: 100vw;
    }

    .popupalert .container{
        border-radius: 5px;
        background: var(--bg);
        position: absolute;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        height: fit-content;
        width: fit-content;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        min-width: 200px;
        text-align: center;
    }

    .background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        opacity: .5;
    }
    /*.popupalert.fade{
           opacity: 1;
        animation: fade forwards;
        animation-delay: 3000ms;
        animation-duration: 1000ms;
        animation-timing-function: ease-out;
    }
      @keyframes fade {
        from {
           opacity: 1;
        }
        to {

           opacity: 0;
        }
    }*/
    .popupalert.confirmed .background{
        background: #6d8d23;
        background: #f1ffcc;
    }
    .popupalert.error .background{
        background: #6d8d23;
        background: #ffe1cc;
    }

    .popupalert .header{

        /*background: rgba(0,0,0,.2);*/
        padding: 3px 0;
    }

    .popupalert .header .label{
        white-space: pre;
        box-shadow: inset 0 -1px 0 0px var(--sub-menu);
        font-size: 23px;
        width: calc(100% - 20px);
        margin-left: 10px;
        margin-bottom: 5px;
    }

    .popupalert.confirmed .header .label{
        color: #6d8d23;
    }
    .popupalert.error .header .label{
        color: #e5154f;
    }

    .popupalert .description{
        text-align: left;
        padding: 10px;
        color: var(--contrast-4);
    }
    .popupalert .button{
        margin: 0 7.5px;
        margin-bottom: 10px;
        min-width: 55px;
    }

    .loading{
        margin: -11px;
        position: relative;
        display: inline-block;
        width: 100%;
    }

      .loading .fa-spinner{
        position:absolute;
        top: -9px;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 18px;
        height: 18px;
        text-align: center;
        padding: 0;
        font-size: 17px;
        color: #cccccc;
        animation-name: spin;
        animation-duration: 2000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }
      @keyframes spin {
        from {
          transform:rotate(0deg);
        }
        to {
          transform:rotate(360deg);
        }
      }

</style>